export default "__VITE_ASSET__B3Rx56l8__"